<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <h1 class="headline font-italic blue-grey--text">
          Language Nerd
        </h1>
      </v-col>
      <v-col class="pt-6" cols="12">
        <LearnDialog />
      </v-col>
      <v-col class="pt-0">
        <v-btn
          x-large
          ripple
          block
          color="green"
          class="white--text"
          @click="$router.push(pathTo.my_vocabulary)">
          {{ $t('myVocabulary.myVocabulary') }}
        </v-btn>
      </v-col>
    </v-row>
    <LanguageDialog v-if="userlanguagesLoaded && !hasUserLanguages" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LearnDialog from '@components/learn_dialog';
import LanguageDialog from '@components/language_dialog';
import { pathTo } from '@/plugins/router/helper';
import { USERS } from '@/config/firestore';
import getDataFrom from '@/mixins/firestore/getDataFrom';

export default {
  name: 'Home',
  components: {
    LearnDialog,
    LanguageDialog,
  },
  mixins: [getDataFrom],
  data: () => ({
    userlanguagesLoaded: false,
    pathTo,
  }),
  computed: {
    ...mapGetters('user', ['hasUserLanguages', 'userIsAuthenticated']),
  },
  methods: {
    ...mapActions('user', ['setUserLanguages', 'setAppLanguage']),

    async getUserLanguageFromDb() {
      const userData = await this.getDataFrom(USERS);
      const { appLanguage, baseLanguage, learningLanguage } = userData;

      this.setUserLanguages({
        base: baseLanguage || '',
        learning: learningLanguage || '',
      });

      this.setAppLanguage(appLanguage || 'en');
      this.$i18n.locale = appLanguage;

      this.userlanguagesLoaded = true;
    },
  },
  async created() {
    if (this.userIsAuthenticated) {
      await this.getUserLanguageFromDb();
    }
  },
};
</script>
